import React, { useEffect } from 'react';
import { useBalance } from '../../hooks';
import { Bookmark, LetterIcon } from '../../icons';
import { useParentProfile } from '../ProfileTemplate';

export default function Wallet() {
  const profile = useParentProfile();
  const { balance, getBalance } = useBalance();

  useEffect(() => {
    getBalance();
  }, [getBalance]);

  return <div className="wallet">
    <div className="mt-4">
      <div className="media align-items-center">
        <LetterIcon />
        <div className="media-body">
          <h6 className="text-primary mb-0">Ethereum address :</h6>
          <span className="text-muted">{profile?.ethereumAddress}</span>
        </div>
      </div>

      <div className="media align-items-center mt-3">
        <Bookmark />
        <div className="media-body">
          <h6 className="text-primary mb-0">UTU Coin balance :</h6>
          <span className="text-muted">{balance?.value}</span>
        </div>
      </div>
    </div>
  </div>;
}